// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-action-bar[data-v-da0a7488]{flex-shrink:0;background:#fff;position:fixed;bottom:var(--footer-height);left:0;right:0;border-top:1px solid var(--v-gray-pale);height:56px;display:flex;justify-content:center;align-items:center;width:1128px;margin:auto}.bottom-action-bar .clear-btn[data-v-da0a7488]{position:absolute;top:50%;left:96px;transform:translateY(-50%)}", ""]);
// Exports
module.exports = exports;
